// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

// TODO: Create a new Header component or refactor the existing one so we can get rid of these @ts-nocheck comments

import { WithMsalProps, withMsal } from '@azure/msal-react'
import ArrowBack from '@mui/icons-material/ArrowBack'
import MenuIcon from '@mui/icons-material/Menu'
import { Toolbar } from '@mui/material'
import classNames from 'classnames'
import { inject } from 'mobx-react'
import moment from 'moment'
import React from 'react'
import { Route, RouteComponentProps, withRouter } from 'react-router-dom'
import Container from '../../common/container/Container'
import NetworkStatusIndicator from '../../common/networkStatusIndicator/NetworkStatusIndicator'
import { i18n } from '../../domain/index'
import RestrictedView from '../auth/RestrictedView'
import type { AuthStore } from '../auth/types'
import withUser from '../auth/withUser'
import Navigation from '../navigation/Navigation'
import { ReminderStore } from '../root/types'
import type { Station } from '../station/stationTypes'
import withActiveStation from '../station/withActiveStation'
import css from './header.css'
import { HeaderBackButton, HeaderWrapper, MenuButton, MojovaAppBar } from './HeaderComponents'

const HEADER_TYPE_DEFAULT = 'default'
export const HEADER_TYPE_SUBPAGE = 'subpage'

export type Tab = {
  label: string
  value: string | number
  requiredPermission?: string
}

type Props = {
  title?: string
  tabs?: Array<Tab>
  tabActive?: string | number
  onTabClick?: (...args: Array<any>) => any
  showLogo?: boolean
  showLogoOnMobile?: boolean
  showNav?: boolean
  headerType?: string

  // ↓ Injected — optional from a typing perspective so consumers don't need to pass them.
  history?: any
  authStore?: AuthStore
  activeStation?: Station | null | undefined
  user?: any
  reminderStore?: ReminderStore
} & Partial<WithMsalProps>

type State = {
  navOpen: boolean
}

const date = moment().format('D.M.YYYY')

@withUser
@withActiveStation
@withMsal
@inject('authStore')
@inject('stationStore')
@inject('reminderStore')
class Header extends React.Component<RouteComponentProps & Props, State> {
  static defaultProps = {
    showLogo: true,
    showLogoOnMobile: false,
    showNav: true,
    headerType: HEADER_TYPE_DEFAULT,
  }

  state: State = {
    navOpen: false,
  }

  closeNav = () => {
    this.setState({
      navOpen: false,
    })
  }

  openNav = () => {
    this.setState({
      navOpen: true,
    })
  }

  logout = (history: Record<string, any>) => {
    this.props.authStore.logout()
    this.props.stationStore.setActiveStationId(null)
    this.props.reminderStore.removeAllSnoozedReminders()
    this.props.msalContext.instance.logoutRedirect({
      postLogoutRedirectUri: process.env.REACT_APP_LOGIN_REDIRECT_URI as string,
    })
  }

  login = (history: Record<string, any>) => {
    history.push('/kirjaudu')
  }

  renderTabs = () => {
    const { tabs, tabActive, onTabClick } = this.props
    if (!tabs) {
      return null
    }

    return tabs.map((tab, i) => {
      const tabElement = (
        <li
          className={classNames(css.tab, {
            [css.active]: tabActive === tab.value,
          })}
          key={i}
        >
          <a onClick={() => (onTabClick ? onTabClick(tab) : null)}>{tab.label}</a>
        </li>
      )

      if (tab.requiredPermission) {
        return (
          <RestrictedView key={i} requiredPermission={tab.requiredPermission}>
            {tabElement}
          </RestrictedView>
        )
      }

      return tabElement
    })
  }

  onStationClick = (user) => {
    const { stations } = this.props.user

    if (stations.length > 1 || !['User', 'Manager'].includes(user.userType)) {
      this.props.history.push('/valitse-toimipaikka')
    } else if (1 === stations.length && this.props.location.pathname !== '/') {
      this.props.history.push('/')
    }
  }

  render() {
    const {
      title,
      tabs,
      showLogo,
      showLogoOnMobile,
      showNav,
      headerType,
      history,
      activeStation,
      authStore,
      user,
      msalContext,
    } = this.props
    const isLoggedIn = msalContext.instance.getActiveAccount() !== null
    return (
      <HeaderWrapper
        className={classNames(css.component, {
          [css.typeDefault]: headerType === HEADER_TYPE_DEFAULT,
          [css.typeSubpage]: headerType === HEADER_TYPE_SUBPAGE,
        })}
        key={title}
      >
        <Navigation open={this.state.navOpen} onClose={this.closeNav} onOpen={this.openNav} />
        <MojovaAppBar className={css.appBar} position='sticky'>
          <Container className={css.container}>
            <Toolbar disableGutters>
              {showNav && headerType === HEADER_TYPE_DEFAULT && (
                <MenuButton color='inherit' aria-label='Menu' onClick={this.openNav}>
                  <MenuIcon />
                </MenuButton>
              )}
              {showNav && headerType === HEADER_TYPE_SUBPAGE && (
                <HeaderBackButton onClick={() => history.goBack()}>
                  <ArrowBack />
                </HeaderBackButton>
              )}
              <div className={css.stationUser}>
                {showLogo && (
                  <span
                    className={classNames(css.logo, {
                      [css.logoMobileVisible]: showLogoOnMobile,
                    })}
                    title={i18n.t('common.reload')}
                    onClick={() => window.location.reload()}
                  >
                    <img src='/abc-logo-text-only.svg' alt='ABC' />
                  </span>
                )}
                {activeStation ? (
                  <span className={css.station} onClick={() => this.onStationClick(user)}>
                    {activeStation.name}
                  </span>
                ) : null}
                {isLoggedIn ? <span className={css.username}>{authStore.getUserFullName()}</span> : null}
              </div>
              <Route
                render={({ history }) =>
                  isLoggedIn && (
                    <span
                      className={css.logoutButton}
                      title={i18n.t('buttons.logout')}
                      onClick={() => this.logout(history)}
                    >
                      <img src='/log-out-icon.svg' alt={i18n.t('buttons.logout')} />
                    </span>
                  )
                }
              />
            </Toolbar>
            {!!tabs && <ul className={css.tabs}>{this.renderTabs()}</ul>}
            <NetworkStatusIndicator />
          </Container>
        </MojovaAppBar>
      </HeaderWrapper>
    )
  }
}

export default withRouter(Header)
